import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/reset.css";
import "zhihao-ui-react/style.css";
import App from "@/App";
// 基础样式与 Vue 项目保持同一事实来源，业务页面迁移时可直接复用旧工具类。
import "@/assets/styles/default.scss";
import "@/assets/styles/_flex.scss";
import "@/assets/styles/_spacing.scss";
import "@/assets/styles/colors.scss";
import "@/assets/styles/base.scss";
import "@/assets/iconfont/iconfont.css";
import "@/styles/global.css";
import "@/components/common/common.css";
import "@/components/media/media.css";
import "@/pages/userMessage/user-message.css";
import "@/pages/registration/registration.css";
import "@/pages/me/me.css";
import { bootstrapApplication } from "@/runtime/bootstrap";
import { LegacyUiProvider } from "@/runtime/LegacyUiProvider";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("缺少 React 根节点 #root");

/** 等待租户与首个用户请求完成，避免权限和标题在首屏后跳变。 */
async function renderApplication() {
    try {
        await bootstrapApplication();
    } catch (error) {
        console.error("console-ui-react bootstrap failed", error);
    }
    createRoot(rootElement!).render(
        <StrictMode>
            <LegacyUiProvider>
                <BrowserRouter basename="/console">
                    <App />
                </BrowserRouter>
            </LegacyUiProvider>
        </StrictMode>
    );
}

void renderApplication();
